var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDottedImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76172 14.9412C1.65715 14.9412 0.761719 15.8498 0.761719 16.9706C0.761719 18.0914 1.65715 19 2.76172 19C3.86629 19 4.76172 18.0914 4.76172 16.9706C4.76172 15.8498 3.86629 14.9412 2.76172 14.9412Z",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76172 7.72975C1.65715 7.72975 0.761719 8.63835 0.761719 9.75916C0.761719 10.88 1.65715 11.7886 2.76172 11.7886C3.86629 11.7886 4.76172 10.88 4.76172 9.75916C4.76172 8.63835 3.86629 7.72975 2.76172 7.72975Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76172 0.518322C1.65715 0.518322 0.761719 1.42692 0.761719 2.54773C0.761719 3.66855 1.65715 4.57715 2.76172 4.57715C3.86629 4.57715 4.76172 3.66855 4.76172 2.54774C4.76172 1.42692 3.86629 0.518322 2.76172 0.518322Z",
    fill: "#C9C9C9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedImage);
export default __webpack_public_path__ + "static/media/dottedImage.065dc5de87040b5d285fec8b5d7e034e.svg";
export { ForwardRef as ReactComponent };